import { Dialog } from "construct-ui";
import FileUploadInputComponent from "../../components/file/file-upload-input.component";
import ModelMappingModel from "../../models/model-mapping/model-mapping.model";
import ViewBase from "../view-base.view";

/**
 * Model mapping - Excel Upload Dialog
 * 
 * The upload dialog used to download and upload according to the filters provided
 * 
 *  @author cmc.pbhieu
 */
export default function ModelMappingExcelUploadDialog() {
  ViewBase.call(this);

  const BOOTSTRAP_INVISIBLE_CLASS = 'invisible';

  const FORM_ID = 'purchaseModelMappingExcelUploadForm';
  const UPLOAD_INPUT_ID = 'modelMappingExcelUploadInput';
  const DOWNLOAD_RESULT_BUTTON_ID = "downloadModelMappingResultButton"

  let resultFileId = '';
  let fileData = null;
  let reloadList = false;
  let showDownloadResultButton = false;

  const DOWNLOAD_EXCEL_TEMPLATE_FILE_PARAMS = {
    storedProcedureCode: "38",
    params: [
      {
        "code": "66",
        "value": "EdiModelMapping"
      }
    ]
  }

  const downloadModelMappingExcelFormat = () => {
    this.showLoading();

    ModelMappingModel.downloadExcelTemplate(DOWNLOAD_EXCEL_TEMPLATE_FILE_PARAMS)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const upload = e => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    this.showLoading();

    const uploadExcelInput = document.querySelector(`#${UPLOAD_INPUT_ID}`);

    ModelMappingModel.uploadExcel(fileData)
      .then((result) => {
        resultFileId = result?.uploadResultGUID;

        if (!resultFileId) {
          this.showErrorMessage(this.getText("EM00000141", "No records found."));
          showDownloadResultButton = false;
          return;
        }

        this.showMessage(
          this.getText('EM00000071', 'Excel Upload Completed Successfully.'),
          this.getText('EM00000004', 'Success')
        );

        reloadList = true;
        showDownloadResultButton = true;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        fileData = null;
        uploadExcelInput.value = null;

        this.hideLoading();
      });
  }

  const downloadExcelResult = () => {
    if (resultFileId === '') return;

    const resultFileName = `model-mapping-result-${resultFileId}`

    this.showLoading();
    ModelMappingModel.downloadResult(resultFileId, resultFileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    view: ({ attrs: { isOpen, onClose } }) => {
      return m(Dialog,
        {
          isOpen,
          onClose: () => { onClose(reloadList); },
          class: 'cui-dialog-s',
          title: this.getText('LT00001020', 'Upload SME I/F Model Mapping'),
          content: m('container',
            m('ol',
              m('li.fw-bold.mb-4',
                m('.mb-2', this.getText('LT00000218', 'Download Template')),
                m('button.btn.btn-primary',
                  { onclick: downloadModelMappingExcelFormat },
                  m('i.bi.bi-file-earmark-arrow-down'),
                  this.getText('LT00000220', 'Excel template')),
              ),
              m('hr'),
              m('li.fw-bold',
                m('.mb-2', this.getText('LT00000197', 'Excel Upload')),
                m('form.needs-validation[novalidate].row', { id: FORM_ID, onsubmit: upload },
                  m('.col-12.mb-4.position-relative',
                    m(FileUploadInputComponent, {
                      id: UPLOAD_INPUT_ID,
                      required: true,
                      accept: '.xlsx,.xls',
                      onInput: (data) => {
                        fileData = data;
                      },
                    }),
                    m('.invalid-tooltip', this.getText('EM00000316', 'Please select a file'))),
                ),
              ),
              m('.d-flex.gap-2.justify-content-end.mb-4.mt-4',
                m(`button.btn.btn-primary[type=submit][form=${FORM_ID}]`, { disabled: fileData == null }, this.getText("LT00000290", "Upload")),
                m('button.btn.btn-white', { onclick: () => { onClose(reloadList) } }, this.getText("LT00000021", "Close"))
              ),

              m(`button.btn.btn-primary.mb-4.${showDownloadResultButton ? '' : BOOTSTRAP_INVISIBLE_CLASS}`,
                {
                  id: DOWNLOAD_RESULT_BUTTON_ID,
                  onclick: downloadExcelResult
                },
                m('i.bi.bi-file-earmark-arrow-down-fill'),
                this.getText('LT00001002', 'Download Results')),
            ),
            this.getBaseViews()
          ),
        }
      );
    }
  }
}